import React, { createContext, useReducer } from "react";
import aliceGPTReducer from "./AliceGPTReducer";
import { OPENAI_MODEL } from "../../Constants/OpenAI";

const initialState = {
    step: 0,
    form: {
        projectName: "",
        domain: "",
        description: "",
        model: OPENAI_MODEL
    },
    subscription: {},
    isLoadingEntities: true,
    formUpdated: false,
    initialAttributesLoaded: true,
    showAdvancedConfigurations: false,
    isPageConfigurationLoading: true,
    entities: [],
    relations: [],
    selectedEntity: [],
    selectedRelation: [],
    namesOfSelectedEntities: [],
    previousNamesOfSelectedEntities: [],
    error: ""
}

const AliceGPTContext = createContext(initialState);

export const AliceGPTContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(aliceGPTReducer, initialState);

    return (
        <AliceGPTContext.Provider value={[state, dispatch]}>
            {children}
        </AliceGPTContext.Provider>
    )
}

export default AliceGPTContext;